exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".password-container {\n  display: flex;\n}", ""]);

// exports
